import axios from "axios";
import { getApiUrl } from "../core/config/api.js";

// Geometry + upload for the WatchFinder image-slot AUTO-FIX (RCListingForm's
// WatchFinderImageSlots). Pure so the output sizes can be unit-tested without
// a real canvas.

// Contain-fit a srcW×srcH image inside a targetW×targetH box, centred. The
// box (the canvas) is always exactly targetW×targetH; the rest is padding.
// Scales up when the source is smaller than the box in both directions.
export const wfFitAndPadRect = (srcW, srcH, targetW, targetH) => {
  const scale = Math.min(targetW / srcW, targetH / srcH);
  const w = srcW * scale;
  const h = srcH * scale;
  return { canvasW: targetW, canvasH: targetH, x: (targetW - w) / 2, y: (targetH - h) / 2, w, h, scale };
};

// The alternative the admin can pick instead of padding: cover-fit — scale
// until the box is FILLED, then crop the overflow. `pos` (0..1) slides the
// crop along the axis that overflows (0 = left/top, 0.5 = centre, 1 =
// right/bottom); the other axis has no overflow so pos has no effect there.
// Same maths as CSS `object-fit: cover; object-position: pos% pos%`, which is
// what the preview uses — so the preview is exactly what gets uploaded.
export const wfCoverRect = (srcW, srcH, targetW, targetH, pos = 0.5) => {
  const scale = Math.max(targetW / srcW, targetH / srcH);
  const w = srcW * scale;
  const h = srcH * scale;
  return { canvasW: targetW, canvasH: targetH, x: (targetW - w) * pos, y: (targetH - h) * pos, w, h, scale };
};

// Share of the box the photo covers when padded — equivalently, the share of
// the photo kept when cropped. 1 = shapes already match.
export const wfAspectOverlap = (srcW, srcH, targetW, targetH) => {
  const a = srcW / srcH;
  const b = targetW / targetH;
  return Math.min(a, b) / Math.max(a, b);
};

// Proportional resize to an exact height; width follows the aspect ratio.
export const wfResizeToHeightSize = (srcW, srcH, targetH) => ({
  canvasW: Math.round(srcW * (targetH / srcH)),
  canvasH: targetH,
});

// Uploads an auto-fixed image. keep_dimensions=1 is load-bearing: by default
// GET /api/files/{id} serves a copy with uniform borders TRIMMED, which cut
// the white padding straight back off — a 1500×1042 photo fixed to 1500×1920
// came back as 1500×1042, so the warning never cleared and WatchFinder got
// the wrong size too. The flag makes the backend serve the bytes as uploaded.
export const wfUploadBlob = async (blob, filename) => {
  const fd = new FormData();
  fd.append("file", blob, filename);
  fd.append("keep_dimensions", "1");
  const { data } = await axios.post(getApiUrl("/api/files"), fd);
  return data?.id ?? null;
};
